import { render, staticRenderFns } from "./LookPicture.vue?vue&type=template&id=fb81f1e8&"
import script from "./LookPicture.vue?vue&type=script&lang=js&"
export * from "./LookPicture.vue?vue&type=script&lang=js&"
import style0 from "./LookPicture.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports